import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  heardNavigation: {
    home: 'Home',
    developmentType: 'Development Type',
    productDisplay: 'Product Display',
    about: 'About Us',
    contact: 'Contact Us',
    changeLang: '中文/English'
  },
  footer: {
    aboutUs: {
      title: 'About us',
      tip1: 'Our team',
      tip2: 'Contact us'
    },
    devType: {
      title: 'Development type',
      tip1: 'Android development',
      tip2: 'iOS development',
      tip3: 'Bluetooth product development',
      tip4: 'WIFIproduct development',
      tip5: 'Mini Program Development'
    },
    case: {
      title: 'Classic Case',
      tip1: 'Smart speaker with screen',
      tip2: 'Smart car charger',
      tip3: 'Smart Cloud Photo Frame'
    }
  },
  home: {
    bannerText: {
      tip1: {
        h1: 'Bluetooth product development',
        h4: 'Anker Roav F2',
        h42: 'BLE/audio'
      },
      tip2: {
        h1: 'AI with screen speaker product development',
        h4: 'Xiaoyan Smartspeaker',
        h42: 'AI/4G'
      },
      tip3: {
        h1: 'WiFi speaker product development',
        h4: 'Dyaudio Music series',
        h42: 'WiFi'
      }
    },
    intro: {
      h: 'Cloudhearing is a supporting software developer serving hardware',
      p: 'Integrate Internet thinking to realize wireless docking of smart devices',
      button: 'Learn more'
    },
    devType: {
      tip1: {
        title: 'iOS/Android App development',
        subtitle: 'Mobile phone application',
        content: 'Software development on smart phones, rich experience in iOS/Android dual-terminal development.'
      },
      tip2: {
        title: 'Android device development',
        subtitle: 'Customized Android system-level applications',
        content: 'Provide software solutions for intelligent hardware running Android system and provide customers with customized functions.'
      },
      tip3: {
        title: 'Background application development',
        subtitle: 'Cloud server',
        content: 'The development of the back-end server function matched with the software provides a stronger back force for the software.'
      },
      tip4: {
        title: 'Bluetooth product development',
        subtitle: 'Bluetooth product supporting software',
        content: 'Provide software supporting services for Bluetooth devices, customized requirements.'
      },
      tip5: {
        title: 'Wi-Fi product development',
        subtitle: 'Wireless product supporting software',
        content: 'Mature Wifi product development, multi-scene software solutions such as speakers and photo frames'
      },
      tip6: {
        title: 'Mini Program Development',
        subtitle: 'Popular WeChat Mini Programs',
        content: 'WeChat applet development helps the product one step further'
      }
    },
    productCase: {
      title: 'Product Case',
      tip1: {
        title: 'Internet of things speaker with screen',
        subtitle: 'AI Voice'
      },
      tip2: {
        title: 'Student Education Tablet',
        subtitle: 'Teaching aids'
      },
      tip3: {
        title: 'WiFi speaker',
        subtitle: 'Stereo pairing'
      },
      tip4: {
        title: 'Smart Cloud Photo Frame',
        subtitle: 'Real-time image transfer'
      },
      tip5: {
        title: 'Bluetooth broadcast control speaker',
        subtitle: 'Intelligent control'
      },
      tip6: {
        title: 'Smart car charger',
        subtitle: 'Car-finding'
      },
      tip7: {
        title: 'HIFI speaker + AI radio',
        subtitle: 'HIFI broadcasts AI radio'
      },
      tip8: {
        title: 'Travel translator',
        subtitle: 'Break through the language barrier'
      }
    },
    clients: {
      tip1: {
        name: '客户名'
      },
      tip2: {
        name: '客户名'
      },
      tip3: {
        name: '客户名'
      },
      tip4: {
        name: '客户名'
      },
      tip5: {
        name: '客户名'
      }
    }
  },
  product: {
    part1: {
      tip1: 'About customers',
      tip2: 'The skills we use in the project/project overview',
      tip3: 'Project details'
    },
    xiaoyan: {
      title: 'Internet of things speaker with screen',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'China Mobile Internet of Things Co., Ltd. is a wholly-owned subsidiary funded and established by China Mobile Communications Corporation. The company operates independently in accordance with a market-oriented mechanism, professionally operates a dedicated Internet of Things network, and develops, designs, and produces dedicated Internet of Things chips, modules and terminals. Develop special products such as Yijutong, Internet of Vehicles, and QR codes, build an open platform for the Internet of Things, promote Internet of Things solutions, and strive to promote the large-scale application of the Internet of Things in various industries.',
        link: 'http://iot.10086.cn/'
      },
      skill: '•Intelligent voice control <br>' +
        '•Multiple methods of high-definition audio and video calls (4G/network/hejia fixed line)<br>' +
        '•Access to massive audio and video source entertainment resources (Migu Music/Migu Video/Migu Listening Books)<br>' +
        '•Family album, share pictures and videos with family<br>' +
        '•Smart alarm clock/memo/news weather and other life skills',
      details: 'In recent years, the concept of smart speakers has continued to be popular and market feedback has been good. In order to promote the Internet of Things solutions and to promote the large-scale application of the Internet of Things in various industries, Xiaoyan smart speakers with screens came into being.<br>' +
        '<br>' +
        'The main function of Xiaoyan smart speaker with screen is intelligent AI wake-up control, high-definition audio and video calls, Wi-Fi+4G support, to meet the needs of all scenarios; equipped with the iFLYTEK AI platform, semantic skills customization, access to massive audio and video resources, Meet user needs.'
    },
    pad: {
      title: 'Student Education Tablet',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: '',
        link: ''
      },
      skill: '',
      details: 'With the advent of the information age of education, traditional teaching can no longer meet the teaching needs, and tablet computers have entered the campus as a teaching facility. This project is an educational tablet developed according to the particularity of vocational education schools. Students can download relevant courseware content through the app market in the tablet. The app provides rich text, pictures, videos and other multimedia content, and can be easily pushed through messages. Teacher-student interaction.'
    },
    dynaudio: {
      title: 'WiFi speaker',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'Dynaudio Music-a well-known top speaker brand from Denmark. Since its establishment in 1977, upholding the concept of "pure original sound, as on-site", Dynaudio has never stopped its tireless pursuit and great enthusiasm for the reproduction of original sound.',
        link: ''
      },
      skill: '•Stereo pairing group<br>' +
        '•WiFi distribution network<br>' +
        '•Support music streaming service, you can play audio sources from major well-known Internet radio stations<br>' +
        '•Play in Music series products through DLNA, Apple AirPlay, and Bluetooth connection',
      details: 'A supporting APP specially developed for Dynaudio\'s smart wireless products, including resource management methods such as setting up a multi-room system, enjoying favorite music, etc., can transfer high-quality music to the Music series of products through DLNA, Apple AirPlay, and Bluetooth connections At the same time, you can also play your favorite music through Audio In, digital optical fiber, HDMI and other wired connection playback methods.'
    },
    Polaroid: {
      title: 'Smart Cloud Photo Album',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: '',
        link: ''
      },
      skill: 'Product Highlights：<br>' +
        '<br>' +
        '•Photo management (crop, rotate, set carousel form)<br>' +
        '•WeChat applet/email image upload<br>' +
        '•Mobile APP to upload pictures, music, video<br>' +
        '•U disk, SD card content display management (this case, rotate, set carousel form, move to local storage)<br>' +
        '•Weather forecast/calendar/alarm clock<br>' +
        '•Human body induction sleep',
      details: 'The traditional photo frame display photos are fixed and troublesome to replace. After a long time, it is easy to cause irreparable damage to the photos. To solve this pain point, the smart cloud photo frame came into being. Through the mobile APP, you can upload photos to the photo frame anytime and anywhere, and then select photos for carousel display. You can change and update the album at any time. In addition, it also supports pushing audio and video files to enrich the user experience.'
    },
    hycat: {
      title: 'Bluetooth broadcast control speaker',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'Buttercat CAT Studio, located in Shanghai, mainly specializes in cultural and creative products such as spacecraft humidifiers, Bluetooth speakers, and power banks. It has cooperated with BILIBILI, Chaodian Culture, NetEase, Tencent, Jingdong and other large enterprises in OEM and ODM projects',
        link: 'http://www.hymcat.com/'
      },
      skill: '•Lighting control<br>' +
        '•Quickly change device voice package<br>' +
        '•Voice package activation code redemption<br>' +
        '•Recording transmission',
      details: 'Shanling Broadcast Control is a professional broadcast control software developed in conjunction with Shanling’s audio products. Based on traditional Bluetooth broadcast control, audio equipment can be controlled through APP to control Bluetooth encoding selection, gain setting, EQ debugging, filter setting, channel debugging, etc. , In addition, it can also analyze the functions of CUE music, folder skipping and device TF card song display and playback control. After different audio devices are connected, different functional interactive pages will be displayed, allowing users to control more intuitively.'
    },
    anker: {
      title: 'Smart car charger',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'Anker belongs to the brand of Anker Innovation Technology Co., Ltd. Anker has entered the top ten of BrandZ™ "Top 50 Chinese Brands Going Overseas" for three consecutive years, won the "Outstanding Made in China Award" issued by Amazon Global, and won the German Red Dot Design Award, iF Design Award and other industrial design awards 24 times.<br>' +
          '<br>' +
          'The main products cover smart digital peripherals such as mobile power supplies, chargers, data cables, Bluetooth peripherals, and key markets covering more than 100 countries and regions including North America, Japan, Europe, and China. Currently, Anker has more than 50 million users worldwide.' +
          '<br>' +
          '<br>' +
          'Cooperative products：\tRoav SmartCharge F3/Roav SmartCharge F2/Roav SmartCharge F0',
        link: 'https://www.anker-in.com'
      },
      skill: '1、Account registration and login-to facilitate the collection of user information, establish a corporate user system, to conduct user analysis, and bring more value to the enterprise;' +
        '<br>' +
        '2、Intelligent car search-realize that the device can realize car search positioning function without built-in GPS chip, which is convenient for car owners to find their own car;' +
        '<br>' +
        '3、FM frequency modulation-FM frequency modulation can be achieved without FM in the car and machine, and supports favorite channels;' +
        '<br>' +
        '4、Voltage monitoring-monitor the voltage situation in the car, help the car safety, travel worry-free' +
        '<br>' +
        '5、Equipment car light adjustment-synchronously control the equipment light, the light moves with you;' +
        '<br>' +
        '6、Intelligently monitor the U disk, which is convenient for users to choose Bluetooth channel or U disk channel to play songs.',
      details: 'Extremely fast connection enables multiple connections in one application. Different models of products will display different functional interactive pages after successfully connecting in the same APP, reducing the embarrassment of users downloading multiple APPs. Under the original basic car charging function, in conjunction with the APP, added value-added functions such as on-board FM frequency modulation, intelligent car search, voltage detection, and light debugging, which enriches the user experience and increases the practicability of the product for car owners.'
    },
    shanling: {
      title: 'HiFi speakers + AI radio',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'Shanling Audio is the domestic high-end HIFI audio brand of Shenzhen Shanling Digital Technology Development Co., Ltd. It is a high-tech joint venture integrating audio equipment R&D, production, processing and sales. With portable players, portable amps, portable decoding amps, HiFi headphones, SACD/CD players, portable lossless players and portable speakers, it enjoys a good reputation in the industry.',
        link: 'https://www.shanling.com'
      },
      skill: '•Multi-device Bluetooth docking compatibility<br>' +
        '•CUE song analysis, professional song information analysis display<br>' +
        '•Folder skip<br>' +
        '•EQ debugging<br>' +
        '•Display and play control of TF card songs<br>' +
        '•Tuning of song filter, channel, gain, encoding selection',
      details: 'Shanling Broadcast Control is a professional broadcast control software developed in conjunction with Shanling’s audio products. Based on traditional Bluetooth broadcast control, audio equipment can be controlled through APP to control Bluetooth encoding selection, gain setting, EQ debugging, filter setting, channel debugging, etc. , In addition, it can also analyze the functions of CUE music, folder skipping and device TF card song display and playback control. After different audio devices are connected, different functional interactive pages will be displayed, allowing users to control more intuitively.'
    },
    translator: {
      title: 'Travel translator',
      text: 'Introduction',
      aboutClient: {
        h: '',
        p: 'hii is a brand from North America that was transformed into cross-border tourism, language learning, and business translation. The professional team has developed leading technologies for speech recognition and instant translation for three years, making 30 different kinds of voice communication barrier-free and people-oriented. Use the new concept of scientific and technological innovation in life, and achieve outstanding intelligent translation products with high-tech humanized design, and enjoy the fun of communication in different languages.',
        link: ''
      },
      skill: 'The hii translator provides mutual translation in 22 languages, so you can go abroad without worry, making communication between different languages no longer difficult.',
      details: 'Based on in-depth algorithms, real-time translation between 22 languages is realized, which can satisfy the worry-free communication in the fields of food, clothing, housing and transportation in different countries.'
    }
  },
  about: {
    part1: {
      title: 'About the team',
      text: 'Shenzhen Yuner Technology Co., Ltd. was established in 2015. It is committed to the software development of professional Bluetooth products, WiFi products, Android device products, and APP. It is a leading IoT development service provider and mobile Internet solution provider. Established cooperative relations with many well-known companies, and classic cases spread across all walks of life. We are a professional Internet team integrating visual design, user experience design, interaction design, and technology research and development. Team members have many years of mobile Internet experience. In the era of rapid development of the Internet of Things, we look forward to helping more customers to catch up. The express train of the Internet of Things creates a high-quality customer experience for customers through innovative spirit and professional services to achieve a win-win situation.',
      tip1: 'Android development engineer 50%',
      tip2: 'iOS development engineer 30%',
      tip3: 'Software testing engineer 10%',
      tip4: 'UI designer 10%'
    },
    part2: {
      title: 'Company culture'
    }
  },
  ...enLocale
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js